import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowBack, Mail, PersonAdd, Lock } from '@mui/icons-material';
import Logo from '../common/Logo';
import { register } from '../../services/userService';
import SEO from '../common/SEO';

const SignupPage = () => {
  const history = useHistory();

  const handleBackToLogin = () => {
    history.push('/login');
  };

  const handleBackToHome = () => {
    history.push('/');
  };

  const startRegistration = async () => {
    try {
      let view = 'provider-staff-allocation-company';
      const resp = await register(view);
      window.location.href = resp.data.authUrl;
    } catch (error) {
      console.error('Registration failed:', error);
    }
  };

  return (
    <>
    <SEO
      title="Sign Up"
      description="Create your free GA4.so account and get $10 in credits. Connect your Google Analytics 4 property and start generating AI-powered reports."
      path="/signup"
    />
    <main className="bg-gradient-to-br from-brand-blue-light to-background min-h-screen py-12 font-sans">
      <div className="container-custom px-4">
        <div className="max-w-2xl mx-auto">
          {/* Header with GA4.so branding */}
          <div className="mb-8 flex items-center justify-between">
            <Logo />
            <button 
              onClick={handleBackToHome}
              className="inline-flex items-center text-primary hover:text-brand-pink text-sm font-inter transition-colors"
            >
              <ArrowBack className="mr-2" style={{ fontSize: 14 }} />
              Back to Home
            </button>
          </div>
          
          <div className="bg-card rounded-lg shadow-lg p-8 border border-border text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-blue-light text-primary mb-6">
              <PersonAdd style={{ fontSize: 28 }} />
            </div>
            
            <h1 className="text-3xl font-bold text-foreground mb-4 font-inter">
              Join GA4.so
            </h1>
            
            {process.env.REACT_APP_ENABLE_SIGNUP === 'true' ? (
              <>
                <p className="text-brand-gray-medium mb-8 max-w-lg mx-auto font-dm-sans">
                  Get started with GA4.so today and unlock powerful analytics insights.
                </p>
                <div className="bg-muted rounded-lg p-6 mb-8">
                  <button
                    onClick={startRegistration}
                    className="w-full bg-primary hover:opacity-90 text-primary-foreground font-medium py-3 px-6 rounded-lg transition-all flex items-center justify-center gap-2 font-inter"
                  >
                    <PersonAdd style={{ fontSize: 18 }} />
                    <span>GET STARTED</span>
                  </button>
                </div>
              </>
            ) : (
              <>
                <p className="text-brand-gray-medium mb-8 max-w-lg mx-auto font-dm-sans">
                  We're currently in invite-only mode to ensure the best experience for early users.
                </p>
                <div className="bg-muted rounded-lg p-6 mb-8">
                <div className="flex items-center justify-center mb-4">
                  <Lock className="text-primary mr-2" style={{ fontSize: 20 }} />
                  <span className="text-foreground font-medium">Invite Only</span>
                </div>
                <p className="text-brand-gray-medium text-sm mb-6">
                  Request access and we'll get back to you within 24 hours.
                </p>
                
                <a
                  href="mailto:hello@ga4.so?subject=Request%20Access%20to%20GA4.so&body=Hi,%0A%0AI'd%20like%20to%20request%20access%20to%20GA4.so.%0A%0AOrganization:%20%0AGoogle%20Analytics%20Property%20ID:%20%0AUse%20case:%20%0A%0AThanks!"
                  className="w-full bg-primary hover:opacity-90 text-primary-foreground font-medium py-3 px-6 rounded-lg transition-all flex items-center justify-center gap-2 font-inter"
                >
                  <Mail style={{ fontSize: 18 }} />
                  <span className="ml-2">Request Access</span>
                </a>
              </div>
              </>
            )}
            
            <div className="text-center border-t border-border pt-6">
              <p className="text-brand-gray-medium font-dm-sans">
                Already have an account?{' '}
                <button 
                  onClick={handleBackToLogin}
                  className="text-primary hover:text-brand-pink font-medium transition-colors cursor-pointer"
                >
                  Sign in
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
    </>
  );
};

export default SignupPage;